import { render, staticRenderFns } from "./UpCrossSellingLayout.vue?vue&type=template&id=56b79784"
import script from "./UpCrossSellingLayout.vue?vue&type=script&lang=js"
export * from "./UpCrossSellingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports